import Button from 'components/Button';
import Image from 'components/Image';

import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  SSection,
  SContainer,
  SDotSvg,
  SPlaceholder,
  SPlayButtonIcon,
  SContentSection,
  SSectionTitle,
  STitle,
  SParagraph,
  SHalfCircleShape,
} from './styles';

import { AiFillPlayCircle } from '@react-icons/all-files/ai/AiFillPlayCircle';

import Modal from 'components/Modal';
import Video from 'components/Video';
import GracefulImage from 'components/GracefulImage';

function CustomVideo({
  title,
  titleHighlight,
  content,
  videoId,
  placeholder,
  useGracefulImage,
}) {
  const [showModal, setShowModal] = useState(false);
  return (
    <SSection>
      <SHalfCircleShape moveY={'-305px'} />
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        modalClassName="video-modal"
      >
        <Video videoId={videoId} autoplay={1} />
      </Modal>
      <SDotSvg isVisibleMobile={true} />
      <SContainer>
        <Row>
          <Col
            xs={12}
            className="d-flex justify-content-center align-items-center"
          >
            <SContentSection>
              <SPlaceholder onClick={() => setShowModal(true)}>
                <SPlayButtonIcon>
                  <AiFillPlayCircle fontSize={80} />
                </SPlayButtonIcon>
                <GracefulImage
                  filename={placeholder}
                  imageData={placeholder}
                  useDeprecatedImage={!useGracefulImage}
                />
              </SPlaceholder>

              <SSectionTitle
                subTitle=""
                title={
                  <STitle>
                    {title} <span className="highlight">{titleHighlight}</span>
                  </STitle>
                }
              />
              <SParagraph>{content}</SParagraph>
            </SContentSection>
          </Col>
        </Row>
      </SContainer>
    </SSection>
  );
}

CustomVideo.propTypes = {
  title: PropTypes.string,
  titleHighlight: PropTypes.string,
  content: PropTypes.node,
  videoId: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  useGracefulImage: PropTypes.bool,
};

export default CustomVideo;
